import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IExamViewModel } from '../exam-view-model.model';
@Injectable({ providedIn: 'root' })
export class OperatorAvailableExamsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorAvailableExams`;
  }
  get(): Observable<IExamViewModel[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IExamViewModel[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
